/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Add Provider Button
 */
import { Button, Dropdown, MenuProps } from 'antd';
import { Down } from '@icon-park/react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

import AddBulkProviderModal from './AddBulkProviderModal';
import { getAddProviderPath } from 'utils/router';

const AddProvider: React.FC = () => {
	const [bulkOpen, setBulkOpen] = useState<boolean>(false);

	const items: MenuProps['items'] = [
		{ key: 'manual', label: <Link to={getAddProviderPath()}>{'Single Provider'}</Link> },
		{ key: 'bulk', label: 'Multiple Providers', onClick: () => setBulkOpen(true) },
	];

	return (
		<>
			<Dropdown menu={{ items }}>
				<Button type='primary'>
					{'Add Provider'}
					<Down size={12} />
				</Button>
			</Dropdown>
			<AddBulkProviderModal open={bulkOpen} onClose={() => setBulkOpen(false)} />
		</>
	);
};

export default AddProvider;
